package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.kds.*
import component.*
import kotlinx.coroutines.channels.*
import models.*

class NetworkInputSystem : IteratingSystem(family { all(NetworkInputDataComponent) }) {

    private val READ_SIZE = 20

    private val channel: Channel<PlayerData> = Channel(capacity = Channel.Factory.UNLIMITED)

    private val receivedData = mutableMapOf<Int, MutableList<Packet>>()

    private val physicChannel: Channel<PlayerPhysicStates> = Channel(capacity = Channel.Factory.UNLIMITED)

    private val physicData = mutableMapOf<Int, PhysicState>()

    suspend fun receiveData(playerId: Int, data: Packet) {
        channel.send(
            PlayerData(playerId, data)
        )
    }

    suspend fun receivePhysicStates(data: PlayerPhysicStates) {
        physicChannel.send(data)
    }

    override fun onTick() {
        receivedData.clear()
        physicData.clear()

        for (i in 1..READ_SIZE) {
            val result = channel.tryReceive()
            val data = result.getOrNull()
            if (data != null) {
                if (!receivedData.containsKey(data.playerId)) {
                    receivedData[data.playerId] = mutableListOf(data.data)
                } else {
                    receivedData[data.playerId]!!.add(data.data)
                }
            }
        }

        // physic states
        val result = physicChannel.tryReceive()
        val data = result.getOrNull()
        if (data != null) {
            data.states.forEach {
                physicData[it.id] = it
            }
        }

        super.onTick()
    }

    override fun onTickEntity(entity: Entity) {
        val inputDataCmp = entity[NetworkInputDataComponent]
        inputDataCmp.inputData = emptyList()

        val data = receivedData[inputDataCmp.id]
        if (data != null) {
            inputDataCmp.inputData = data
        }

        val physicState = physicData[inputDataCmp.id]
        if (physicState != null) {
            inputDataCmp.physicData.enqueue(physicState)
//            if (inputDataCmp.physicData.size >= 5) {
//                inputDataCmp.canReadPhysicState = true
//            }
        }
    }
}

data class PlayerData(val playerId: Int, val data: Packet)
